/**
 * Маркер «плавающего» слоя: поповер, меню или модалка, которые визуально
 * принадлежат редактору, но в DOM живут в портале.
 *
 * Нужен редакторам ячеек: клик в календарь или в список выбора приходит как
 * blur с `relatedTarget` вне редактора, и без маркера редактор закрылся бы
 * раньше, чем пользователь выбрал значение.
 */
export const portalOverlayClassName = 'rf-portal-overlay';

/** Принадлежит ли узел плавающему слою редактора. */
export const isInPortalOverlay = (element: Element | null | undefined): boolean =>
    !!element?.closest(`.${portalOverlayClassName}`);
